import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 12h2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "6", x: "2", y: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileDigit";
const FileDigit = memo(themed(Icon));
export {
  FileDigit
};
//# sourceMappingURL=file-digit.js.map
